import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { canonicalFor, usePageMeta } from '../../hooks/usePageMeta';
import { PageHeader } from '../../components/page/PageHeader';
import { ContentSection } from '../../components/page/ContentSection';
import { TechAssistCallout } from '../../components/page/TechAssistCallout';
const resources = [{
  title: 'Starting Data',
  href: '/technical-resources/starting-data/',
  description: 'Published starting guidance for 6061-T6 aluminum, oxygen-free copper and titanium in one table, with units and source conditions.'
}, {
  title: 'Tool Selection',
  href: '/technical-resources/tool-selection/',
  description: 'Match the holder shank to your turret, choose insert grade, geometry and radius, then talk through the application.'
}, {
  title: 'Workholding & Safety',
  href: '/technical-resources/safety/',
  description: 'CNC-lathe-only setup checks and the published security-of-workholding chart for 6061-T6 aluminum.'
}];
export function TechnicalResources() {
  usePageMeta({
    title: 'Technical Resources & Assistance: 650-224-7511 | Robertson Precision',
    description: 'Call Shear Geometry technical assistance at 650-224-7511. Starting data, tool selection and workholding and safety references for CNC lathe setups.',
    canonical: canonicalFor('/technical-resources/')
  });
  return <>
      <PageHeader eyebrow="Technical Resources" title="Technical Resources" lead="Start with a call: the technical staff can review your material, machine and workholding before the first cut. The references below summarize the published guidance." crumbs={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'Technical Resources'
    }]} data-id="element-863" data-mp="2q38qit2dz1iz" />

      <ContentSection id="assistance" tone="warm" data-id="element-864" data-mp="14qyyjgd44rec">
        <TechAssistCallout location="technical-resources" showPrepList data-id="element-865" data-mp="19qtl57puuutl" />
      </ContentSection>

      <ContentSection id="references" title="References" data-id="element-866" data-mp="popc3suf4e9q">
        <ul className="grid gap-px border border-rule bg-rule lg:grid-cols-3" data-id="element-867" data-mp="po7a0fl2r5tw">
          {resources.map(r => <li key={r.href} className="flex bg-white" data-id="element-868" data-mp="lp86mzezrh4k">
              <Link to={r.href} className="group flex w-full flex-col p-6 transition-colors duration-150 ease-precise hover:bg-warm lg:p-7" data-id="element-869" data-mp="gvded7lblttv">
                <span className="font-display text-[21px] font-medium text-navy group-hover:text-copper" data-id="element-870" data-mp="6yhfltl84m2i">
                  {r.title}
                </span>
                <span className="mt-3 text-[14.5px] leading-relaxed text-graphite/85" data-id="element-871" data-mp="218sdel7xrue">
                  {r.description}
                </span>
                <span className="mt-auto inline-flex items-center gap-2 pt-6 text-[14px] font-semibold text-navy" data-id="element-872" data-mp="3p4m0tx72cari">
                  Open
                  <ArrowRightIcon aria-hidden="true" className="h-4 w-4 text-copper" data-id="element-873" data-mp="1sasm96f2i63r" />
                </span>
              </Link>
            </li>)}
        </ul>
      </ContentSection>
    </>;
}